var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,36.05v0A24.14,24.14,0,0,1,41,54.34a24.29,24.29,0,0,1-17.93,0A24.1,24.1,0,0,1,8.23,36.05H56m0-4H8.23a4,4,0,0,0-4,4.69A28.31,28.31,0,0,0,42.56,58.05,28,28,0,0,0,59.94,36.74a4,4,0,0,0-4-4.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,8a1,1,0,0,1,.9.53l0,.06,0,.06L25,32h-2.1L8.15,9.44a.91.91,0,0,1-.08-.7,1,1,0,0,1,.47-.6A1,1,0,0,1,9,8M9,4a5.08,5.08,0,0,0-2.51.67,5,5,0,0,0-1.84,6.84L20.67,36H32.31L13.43,6.51A5.08,5.08,0,0,0,9,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,31.93H29.73L13.43,6.51a5.08,5.08,0,0,0-6.9-1.83A4.93,4.93,0,0,0,4.69,11.5L18,31.93H8.23a4.05,4.05,0,0,0-4,4.72A28.29,28.29,0,0,0,21.62,58.16a28.27,28.27,0,0,0,20.94,0A28.26,28.26,0,0,0,59.94,36.65,4,4,0,0,0,56,31.93ZM8.15,9.44a.91.91,0,0,1-.08-.7,1,1,0,0,1,.47-.6A1,1,0,0,1,9,8a1.06,1.06,0,0,1,.9.52l0,.07,0,.06L25,31.93H22.84ZM41,54.42a24.16,24.16,0,0,1-17.93,0A24.26,24.26,0,0,1,8.23,36H56v0A24.33,24.33,0,0,1,41,54.42Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipe);
export default __webpack_public_path__ + "static/media/Recipe.217c0f7a.svg";
export { ForwardRef as ReactComponent };